import { render } from "./CrmPointsCard.vue?vue&type=template&id=5f661be8&scoped=true"
import script from "./CrmPointsCard.vue?vue&type=script&lang=js"
export * from "./CrmPointsCard.vue?vue&type=script&lang=js"

import "./CrmPointsCard.vue?vue&type=style&index=0&id=5f661be8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f661be8"]])

export default __exports__